export type DurationCallback = (seconds: number) => void;

export interface DurationObj {
  minutes: number;
  seconds: number;
}

export enum FOCUS_STATE {
  MINUTES = 'MINUTES',
  SECONDS = 'SECONDS',
}

export enum CONTROL_STATE {
  UP = 'UP',
  DOWN = 'DOWN',
}
